module.exports = __webpack_public_path__ + "5c08069838ff24c3e0cd974ed207c502.svg";